import MapCard from './card';

export default MapCard;

export { type MapCardProps } from './card';
